import { Component, OnInit } from '@angular/core';
import { ObjectCheckModel } from '../../../shared/models/live-abroad.model';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { BUSINESS_CONST } from '../../../shared/constants/business.constants';
import { ConfigurationService } from '../../../shared/services/configuration/configuration.service';
import { navCode } from 'src/app/shared/constants/channel.constants';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';

@Component({
  selector: 'app-receive-card',
  templateUrl: './receive-card.component.html',
  styleUrls: ['./receive-card.component.scss'],
})
export class ReceiveCardComponent implements OnInit {

  listReceiveCard: any[] = [];
  selectReceive = new ObjectCheckModel();
  stateButton = false;
  viewOptionMultiProduct: boolean;

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private configurationService: ConfigurationService,
    private bitacoraService: BitacoraService,

    ) {
    this.headerService.show(true, true, true);
  }

  ngOnInit() {
    this.listReceiveCard = [];
    this.navigationService.pageLoadTag(false, ['', '', 'pv225', '']);
    const office = {
      label: this.copyService.copies.receive_card_option_office,
      elementId: '1',
      checked: this.abreCuentasService.getReceiveCard() && this.abreCuentasService.getReceiveCard() === '1',
    };
    this.validateChecked(office);
    this.listReceiveCard.push(office);

    const house = {
      label: this.copyService.copies.receive_card_option_house,
      elementId: '2',
      checked: this.abreCuentasService.getReceiveCard() && this.abreCuentasService.getReceiveCard() === '2',
    };
    this.validateChecked(house);
    this.listReceiveCard.push(house);
    this.viewOptionMultiProduct = this.abreCuentasService.viewOptionMultiProduct;
  }

  validateChecked(element: any) {
    if (element.checked) {
      this.selectReceive = element;
      this.stateButton = true;
    }
  }

  /**
   * Summary Set propertys to Live Abroad
   * @param event
   */
  selectradioShippingMethod(option: any) {
    this.selectReceive = {
      ...option,
      checked: true,
    };
    this.abreCuentasService.setReceiveCard(this.selectReceive.elementId);
    this.stateButton = true;
  }

  next() {
    if (!this.stateButton) {
      return;
    }
    if (this.viewOptionMultiProduct) {
      if (this.selectReceive.elementId === '1') {
        this.bitacoraService.saveDataInBitacora('product_addres_work');
        this.abreCuentasService.setOfficeStatus(true);
      } else {
        this.bitacoraService.saveDataInBitacora('product_addres_home');
        this.abreCuentasService.setOfficeStatus(false);
      }
      let productList = this.abreCuentasService.getProductsSelects();
      if (productList.find(find => find.product_type == BUSINESS_CONST.PRODUCT_TYPE_TC && this.abreCuentasService.getOfficeStatus())) {
        this.configurationService.sendCardInformation();
      } else {
        this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
      }
    } else {
      if (this.selectReceive.elementId === '1') {
        this.abreCuentasService.setOfficeStatus(true);
        this.navigationService.nextStep(navCode[200]);
      } else {
        this.navigationService.nextStep(navCode[201]);
      }
    }
  }

}
